(() => {
  if (window.pc27SupportReady) return;
  window.pc27SupportReady = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-pc27-support]');
    if (!link) return;
    if (window.Intercom) {
      event.preventDefault();
      window.Intercom('show');
    }
  });
})();
